import Image from "next/image";
import React from "react";
import Bear from "src/assets/images/bear-market.png";

interface SnowflakeIconProps {
  isTrialUser?: boolean;
  className?: string;
}

const SnowflakeIcon: React.FC<SnowflakeIconProps> = ({
  isTrialUser = false,
  className = "w-4 h-4",
}) => {
  return (
    <div className="relative group/bear inline-flex shrink-0 items-center">
      <Image
        src={Bear}
        alt="Bear"
        width={16}
        height={16}
        className={`shrink-0 opacity-80 transition-transform dark:group-hover/bear:scale-110 ${className}`}
      />
      {!isTrialUser && (
        <div className="absolute z-10 hidden w-80 top-[-60px] translate-y-0 sm:w-max sm:top-1/2 sm:-translate-y-1/2 group-hover/bear:block bg-[#30324e] text-white text-sm p-2 rounded-md shadow-lg border border-[#394564] left-full ml-0 sm:ml-2">
          The sector for this stock is currently in Bearish phase at this
          moment.
          <div className="absolute hidden sm:block right-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-r-4 border-r-[#30324e]"></div>
        </div>
      )}
    </div>
  );
};

export default SnowflakeIcon;
